module.exports = __webpack_public_path__ + "static/media/game-plan-1.49844ff2.png";